/**
 * A dealflow slot that shows a SEALED company's record instead of its deal card
 * (119-07). A closed / acquired / bankrupt company has no profile to show, no
 * stage to move and no data room to open, so the row is the read-only
 * ClosedCompanyCard and its only action is opening the detail record.
 * Operating deals render `children` (the ordinary DealflowCard) untouched.
 */

import React from 'react';
import { View } from 'react-native';
import { ClosedCompanyCard } from '@/components/company/ClosedCompanyCard';
import { webStyle } from '@/lib/platform';
import type { SealedDealState } from '@/lib/dealflow/sealed-deals';

export function SealedDealSlot({
  dealId,
  state,
  layout,
  isDesktop,
  onRetry,
  onView,
  children,
}: {
  dealId: string;
  state: SealedDealState;
  layout?: 'list' | 'grid' | 'compact' | string;
  isDesktop?: boolean;
  onRetry: () => void;
  onView: (dealId: string) => void;
  children: React.ReactNode;
}) {
  if (state.kind === 'operating') return <>{children}</>;
  return (
    <View
      testID={`sealed-deal-${dealId}`}
      style={layout === 'grid' ? (isDesktop ? webStyle({}, { width: 'calc(50% - 6px)' }) : { width: '100%' }) : undefined}
    >
      <ClosedCompanyCard
        card={state.kind === 'sealed' ? state.card : undefined}
        loading={state.kind === 'loading'}
        error={state.kind === 'error' ? true : undefined}
        onRetry={onRetry}
        onPress={state.kind === 'sealed' ? () => onView(dealId) : undefined}
        testID={`closed-deal-${dealId}`}
      />
    </View>
  );
}
